export enum RequestCandidateTableType {
    Pending = 'pending',
    Approved = 'approved',
    Denied = 'denied',
}